// This is not a specific slice. But these constants used in nested reducers/slices.

const sliceConstants = {
	sectionName: 'dashboard',
};

export const { sectionName } = sliceConstants;

export default sliceConstants;
